<div class="container animated fadeInRight" *ngIf="!mostrarFormulario">
  <app-lfsa-card [innTemplate]="grid" [titulo]="'Mantener aplicaciones por usuario'" [efecto]="true" [colapseName]="'grid'"
    [banderaColapse]='true'></app-lfsa-card>
  <ng-template #grid>
    <div class="row">
      <form [formGroup]="formularioBuscar" novalidate class="form-group">
        <div class="row">
          <div [class]="'col-md-8'">
            <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formularioBuscar.get('userName')"
              [placeholder]="'Nombre Usuario activo o inactivo'" formControlName="userName" [label]="'Ingrese Nombre Usuario*'" [type]="'text'" [id]="'userName'">
            </app-lfsa-input>
          </div>
          <div [class]="'col-md-2'">
            
            <div *ngIf="!loading">
              <label>&nbsp;</label><br>
              <button class="btn btn-success btn-block" [disabled]="formularioBuscar.invalid"
                (click)="buscarUsuario()">Buscar</button>
            </div>
          </div>
          <div [class]="'col-md-2'">
            <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
            <div *ngIf="!loading">
              <label>&nbsp;</label><br>
              <button class="btn btn-success btn-block" 
                (click)="listarTodos()">Listar Activos</button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="row">
      <div class="col-md-12">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
            No existen datos para la lista de Aplicaciones.
          </div>
          <div *ngIf="!listaVacia">
            <div class="row">
              <div [class]="'col-md-8'">
                <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter "
                  (keyup)="onQuickFilterChanged()" #quickFilter />
              </div>
              <div [class]="'form-group col-md-4'">
                <button class="btn btn-success btn-block" (click)="callModalCrear()">Agregar</button>
              </div>
            </div>
            <br>
            <hr>
            <ag-grid-angular #agGrid class=" {{seguridadDAModulo.agGrid.class}}" [ngStyle]="seguridadDAModulo.agGrid.style"
              id="{{seguridadDAModulo.agGrid.id}}" [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs"
              [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)" [pagination]="true"
              >
            </ag-grid-angular>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>

<!-- MODAL CREAR APLICACION USER -->
<app-lfsa-modal [innTemplate]="enviarModalCrear" [titulo]="'Asignar Aplicación por Usuario'" [idButton]="'abrirModalCrear'" [idOpen]="'ModalCrear'"
  [idClose]="'cerrarModalCrear'"></app-lfsa-modal>
<ng-template #enviarModalCrear>
  <form [formGroup]="formularioCrear" novalidate class="form-group">
    <div class="row">
      <div [class]="'col-md-12'">
        <app-lfsa-combo-box [mostrarImg]="false" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbEmpleado" (change)="detectUsername()"
          formControlName="cedula" [control]="formularioCrear.get('cedula')" [claseLabel]="'letrasDanger'" [label]="'Empleado*'" [id]="'cedula'">
        </app-lfsa-combo-box>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-combo-box [mostrarImg]="false" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbAplicacion" 
          formControlName="appId" [control]="formularioCrear.get('appId')" [claseLabel]="'letrasDanger'" [label]="'Aplicación*'" [id]="'appId'">
        </app-lfsa-combo-box>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formularioCrear.get('userName')"
          [placeholder]="'Nombre Usuario'" formControlName="userName" [label]="'Ingrese Nombre Usuario*'" [type]="'text'" [id]="'userName'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formularioCrear.invalid"
            (click)="crearAplicacionByUser()">Crear</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<!-- MODAL EDITAR APLICACION USER -->
<app-lfsa-modal [innTemplate]="enviarModalEditar" [titulo]="'Actualizar Aplicación por Usuario'" [idButton]="'abrirModalEditar'" [idOpen]="'ModalEditar'"
  [idClose]="'cerrarModalEditar'"></app-lfsa-modal>
<ng-template #enviarModalEditar>
  <form [formGroup]="formularioEditar" novalidate class="form-group">
    <div class="row">
      <div [class]="'col-md-12'">
        <app-lfsa-combo-box [mostrarImg]="false" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbEmpleado" 
          formControlName="cedula" [control]="formularioEditar.get('cedula')" [claseLabel]="'letrasDanger'" [label]="'Empleado*'" [id]="'cedula'" [habilitar]="true">
        </app-lfsa-combo-box>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-combo-box [mostrarImg]="false" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbAplicacion" 
          formControlName="appId" [control]="formularioEditar.get('appId')" [claseLabel]="'letrasDanger'" [label]="'Aplicación*'" [id]="'appId'">
        </app-lfsa-combo-box>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formularioEditar.get('userName')"
          [placeholder]="'Nombre Usuario'" formControlName="userName" [label]="'Ingrese Nombre Usuario*'" [type]="'text'" [id]="'userName'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formularioEditar.invalid"
            (click)="editarAplicacionByUser()">Actualizar</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>
